(function($) {
	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();


	/* Document ready functions */
	$(document).ready(function (){

		// Top section heights
    $('.widescreen-section .swiper-slide, .widescreen-section .bg-video-wrapper').css({"height":windowHeight});
    $(".widescreen-section .content-txt").each(function(){
		  var txt_margin = $(this).outerHeight() /2;
      $(this).css({"margin-top":-txt_margin-30});
		});

		window.sr = ScrollReveal();
		sr.reveal('.section-ease', { duration: 1000 });

	});

	$(window).resize(function () {

		// Get Window Width and Height on resize
		windowWidth = $(window).outerWidth();
		windowHeight = $(window).height();

		// Top section heights
    $('.widescreen-section .swiper-slide, .widescreen-section .bg-video-wrapper').css({"height":windowHeight});
    $(".widescreen-section .content-txt").each(function(){
		  var txt_margin = $(this).outerHeight() /2;
      $(this).css({"margin-top":-txt_margin-70});
		});


	});

})(jQuery);
